import { ClockIcon } from "@heroicons/react/24/outline"
import { useTranslation } from "react-i18next"

export default function WelcomeVisual() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="relative">
        <span className="absolute -left-6 -top-4 animate-scale-in text-3xl [animation-delay:400ms]">
          ✨
        </span>
        <span className="absolute -bottom-2 -right-7 animate-scale-in text-3xl [animation-delay:600ms]">
          🧠
        </span>
        <img
          alt=""
          className="h-32 w-32 animate-float rounded-[32px] shadow-card-hover"
          src="/android-chrome-512x512.png"
        />
      </div>

      <p className="flex animate-fade-up items-center gap-2 rounded-full bg-vm-surface px-4 py-2 text-sm font-medium text-vm-ink shadow-card [animation-delay:500ms]">
        <ClockIcon className="h-4 w-4 text-vm-primary" />
        {t("pages.onboarding.visuals.welcome.duration")}
      </p>
    </div>
  )
}
